var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNgnFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13287_110884)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_13287_110884)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-6.87988 -1.65332H30.8789V26.6666H-6.87988V-1.65332Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2927 -1.65332H30.8789V26.6666H18.2927V-1.65332ZM-6.87988 -1.65332H5.70641V26.6666H-6.87988V-1.65332Z",
    fill: "#36A100"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13287_110884"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.46875,
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_13287_110884"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37.76,
    height: 28.32,
    fill: "white",
    transform: "translate(-6.87988 -1.65332)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNgnFlag);
export default __webpack_public_path__ + "static/media/ngn-flag.9d28a3534da2547e9410ceaacba3ede6.svg";
export { ForwardRef as ReactComponent };